/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';

/**
 * CheckoutModulesStateShare Input Action
 */

export class SameBillingAddressShareInput implements IActionInput {
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `sameBillingAddressState`;
    public getCacheObjectType = () => 'sameBillingAddressState';
    public dataCacheType = (): CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IUseSameBillingAddressSharedState {
    isBillingAddressSame?: boolean;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new SameBillingAddressShareInput();
};
/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function useSameBillingAddressStateAction(
    input: SameBillingAddressShareInput,
    ctx: IActionContext
): Promise<IUseSameBillingAddressSharedState> {
    return {
        isBillingAddressSame: undefined
    };
}

/**
 * SampleState - create action
 */
export default createObservableDataAction<IUseSameBillingAddressSharedState>({
    action: <IAction<IUseSameBillingAddressSharedState>>useSameBillingAddressStateAction,
    input: createInput
});
